import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import {
  SegmentClassificationArrayModel,
  SegmentClassificationModel,
} from "../../models/SegmentClassificationModel";

const initialSegmentClassificationState: SegmentClassificationArrayModel = {
  all_SegmentClassifications: [],
  particular_SegmentClassification: {
    segmentclassid: 0,
    name: "",
    isBaseLoad: false,
    isActive: false,
  },
  isSegmentClassificationsFetching: false,
};
const SegmentClassificationSlice = createSlice({
  name: "SegmentClassification",
  initialState: initialSegmentClassificationState,
  reducers: {
    setSegmentClassifications(
      state,
      action: PayloadAction<SegmentClassificationModel[]>
    ) {
      state.all_SegmentClassifications = action.payload;
    },
    setParticularSegmentClassification(
      state,
      action: PayloadAction<SegmentClassificationModel>
    ) {
      state.particular_SegmentClassification = action.payload;
    },
    setIsSegmentClassificationsFetching(state, action: PayloadAction<boolean>) {
      state.isSegmentClassificationsFetching = action.payload;
    },
  },
});
export default SegmentClassificationSlice;
